import React, { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { Button, Spinner } from 'react-bootstrap'
import "./GettingStarted.css"
import logo from '../asset/image/main-logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper, faCalendarAlt  } from '@fortawesome/free-solid-svg-icons'
import { getContent, acceptTerm } from '../Network/Content'
import Parser from 'html-react-parser';

function GettingStarted({ onFinishSetup }) {
    const [isLoading, setLoading] = useState(false)
    const [page, setPage] = useState(1)

    const renderPage = () =>{
        switch(page){
            case(1):
                return(
                <WelcomePage onClickContinue={()=>setPage(2)}/>
                )
            case(2):
                return(
                <TermAndConditionPage
                onLoading={(loading)=>setLoading(loading)}
                onAccepted={()=>onFinishSetup()}/>
            )
        }
    }

    return (
        <div id="getting-start">
            { isLoading ?
            <div className="loading-screen">
                <Spinner animation="border" variant="primary"/>
            </div>
            : null
            }
            { renderPage() }
        </div>
    )
}

function WelcomePage({ onClickContinue }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.getting_start

    return(
        <div className="info">
            <div>
                <img src={logo} className="logo"/>
                <div>

                </div>
            </div>
            <div className="title">{lang.welcome_lifelink}</div>
            <div className="desc">{lang.welcome_desc}</div>
            <hr/>
            <Button onClick={onClickContinue}>
                {lang.continue}
            </Button>
        </div>
    )
}

function TermAndConditionPage({ onLoading, onAccepted }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.getting_start
    const [content, setContent] = useState("")
    const [disabledBtn, setDisableBtn] = useState(false)

    const acceptTermandCondition = () =>{
        onLoading(true)
        setDisableBtn(true)
        acceptTerm(
            ()=>{
                onLoading(false)
                onAccepted()
            },
            (error)=>{
                onLoading(false)
                setDisableBtn(false)
            }
        )
    }

    useEffect(()=>{
        const fetchData = () =>{
            onLoading(true)
            getContent(1,
                (data)=>{
                    setContent(data.content)
                    onLoading(false)
                },
                (error)=>{
                    onLoading(false)
                })
        }
        fetchData()
    },[])

    return(
        <div className="term">
            <div className="title">{lang.term_and_condition}</div>
            <div className="term-area">
                {Parser(content)}
            </div>
            <hr/>
            <div style={{ textAlign: 'center' }}>
                <Button 
                style={{ width: "100%" }} 
                disabled={disabledBtn}
                onClick={()=>acceptTermandCondition()}>
                    {lang.agree}
                </Button>
            </div>
        </div>
    )
}

export default GettingStarted
